import { stringify } from 'query-string';
import { PB_QUERY_CONST, PAGINATION_QUERY_CONST } from '../../../constants';

const buildPaginationUrl = (name, page, query, url, componentId) => {
  const newQuery = { ...query, [`${PB_QUERY_CONST}[${name}]${PAGINATION_QUERY_CONST}`]: page };
  const stringQuery = stringify(newQuery);
  return `${url}?${stringQuery}${componentId ? `#${componentId}` : ''}`;
};

export default buildPaginationUrl;
